<template>
    <div class="ag-cell-edit-wrapper">
        <div
            role="presentation"
            class="ag-cell-editor ag-labeled ag-label-align-left"
        >
            <div
                class="ag-wrapper"
            >
                <select v-model="value" class="ag-input-field-select" @change="onChange(value)">
                    <option v-if="loading" :value="null">...</option>
                    <option v-for="option in options" :value="option.value">
                        {{ option.text }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
    import isFunction from 'lodash/isFunction';

    export default {
        data() {
            return {
                loading: false,
                value: null,
                options: [],
            }
        },
        created() {
            if (isFunction(this.params.options)) {
                this.loading = true;
                Promise.resolve(this.params.options())
                    .then(options => {
                        this.value = this.params.value;
                        this.options = options;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                this.value = this.params.value;
                this.options = this.params.options;
            }
        },
        methods: {
            onChange(value){
                if (isFunction(this.params.onChange)) {
                    this.params.onChange(this.params, value)
                }
            },
            getValue() {
                return this.value;
            },
        }
    }
</script>

<style lang="scss" scoped>
    :deep(.ag-input-field-select) {
        color: #404040 !important;
        text-decoration: none !important;

        border: none;
        width: 100%;
        height: 100%;
    }
</style>
